import Axios from 'axios';
import _ from 'lodash';
import store from 'store/store';
import {baseUrl, botActions, redirect_URL, requestHeader} from '../../config';
import {
  AppraisalRequestContext,
  beginAppraisalRequest,
  finishAppraisalRequest,
  isAppraisalRequestSessionCurrent,
  isLatestAppraisalRequest,
} from '../../appraisal/appraisalRequestSession';
import {encryptData, getCaptchaToken} from '../../utils/handler';
import {CatchReturnError} from './actionHandler';
import {ALTERNATES_LOADING, ALTERNATE_DOMAINS, APPRAISAL_ALLOWANCE, APPRAISAL_ALLOWANCE_ERROR, APPRAISAL_ALLOWANCE_LOADING, APPRAISAL_DETAIL, APPRAISAL_ERROR, APPRAISAL_LOADING, APPRAISAL_SEARCH_HISTORY, APPRAISAL_SEARCH_HISTORY_ERROR} from './types';
// requestHeader.Authorization = localStorage.getItem('saw-token') || ""
const getAppraisalRequestConfig = (request: AppraisalRequestContext) => ({
  cancelToken: request.cancelToken,
  headers: request.authToken
    ? {Authorization: request.authToken}
    : {},
});

const mergeAppraisalHistory = (...historyLists: any[][]): any[] => {
  const seenDomains = new Set<string>();
  return historyLists.reduce<any[]>((mergedHistory, history) => {
    history.forEach(appraisal => {
      const domain = String(appraisal?.domain || appraisal?.domainName || '')
        .trim()
        .toLocaleLowerCase();
      if (!domain || !seenDomains.has(domain)) {
        mergedHistory.push(appraisal);
        if (domain) seenDomains.add(domain);
      }
    });
    return mergedHistory;
  }, []);
};

export const getConditionAndDescription = (type: string) => {
  return Axios.get(baseUrl + '/exhibitConditions/' + type, requestHeader)
    .then((res) => {
      let response = res['data'];
      return response;
    })
    .catch((err) => {
      return CatchReturnError(err);
    });
};

export const newsLetterApi = (email: string) => {
  return Axios.post(baseUrl + '/newsLetterApi', { email }, requestHeader)
    .then((res) => {
      let response = res['data'];
      return response;
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};
export const getAlternateDomains = (domain: string) => {
  store.dispatch({ type: ALTERNATES_LOADING, payload: true });
  return Axios.get(baseUrl + '/alternateDomains/' + encryptData(domain), requestHeader)
    .then((res) => {
      let response = res['data'];
      store.dispatch({ type: ALTERNATE_DOMAINS, payload: response });
      return response;
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};

export const recentlySearchedAppraisal = () => {
  // const appraisalSearchHistoryError = store.getState().appraisalReducer.appraisalSearchHistoryError;
  const request = beginAppraisalRequest('history', true);

  return Axios.get(baseUrl + '/recentSearch', getAppraisalRequestConfig(request))
    .then((res) => {
      if (!isLatestAppraisalRequest(request)) return undefined;
      let response = res['data'];
      if (res.status === 200) {
        const {appraisalSearchHistory} = store.getState().appraisalReducer;
        const mergedHistory = mergeAppraisalHistory(
          _.isArray(appraisalSearchHistory) ? appraisalSearchHistory : [],
          _.isArray(response) ? response : [],
        );
        store.dispatch({
          type: APPRAISAL_SEARCH_HISTORY,
          payload: mergedHistory,
        });
        return mergedHistory;
      } else {
        store.dispatch({ type: APPRAISAL_SEARCH_HISTORY_ERROR, payload: ' ' });
      }
      return response;
    })
    .catch((err) => {
      if (!Axios.isCancel(err) && isLatestAppraisalRequest(request)) {
        CatchReturnError(err);
      }
      return undefined;
    })
    .finally(() => finishAppraisalRequest(request));
};

export const getAppraisalAllowance = (domainName: string = '') => {
  const request = beginAppraisalRequest('allowance', true);
  const queryParams: string[] = [];
  if (domainName)
    queryParams.push(`domainName=${encodeURIComponent(domainName)}`);
  const query = queryParams.length ? `?${queryParams.join('&')}` : '';
  store.dispatch({type: APPRAISAL_ALLOWANCE_LOADING, payload: true});
  return Axios.get(
    baseUrl + `/appraisalAllowance${query}`,
    getAppraisalRequestConfig(request),
  )
    .then((res) => {
      const allowance = res['data'];
      if (isLatestAppraisalRequest(request)) {
        store.dispatch({type: APPRAISAL_ALLOWANCE, payload: allowance});
        return allowance;
      }
      return undefined;
    })
    .catch((err) => {
      if (!Axios.isCancel(err) && isLatestAppraisalRequest(request)) {
        CatchReturnError(err);
        if (isLatestAppraisalRequest(request)) {
          store.dispatch({type: APPRAISAL_ALLOWANCE_ERROR, payload: true});
        }
      }
      return undefined;
    })
    .finally(() => finishAppraisalRequest(request));
};
export const updateCondition = (descriptionUID: string, payload: any) => {
  return Axios.patch(baseUrl + '/exhibitConditions/' + descriptionUID, payload, requestHeader)
    .then((res) => {
      let response = res['data'];
      return response;
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};
export const getBlogs = () => {
  return Axios.get(baseUrl + '/getBlogsFromSawSite/', requestHeader)
    .then((res) => {
      let response = res['data'];
      return response;
    })
    .catch((err) => {
      return false;
    });
};

export const estibotApprasisal = async (domainName: string, token: string) => {
  const request = beginAppraisalRequest('appraisal');
  let botToken: string;
  try {
    botToken = token
      ? token
      : await Promise.race([
          getCaptchaToken(botActions.appraisal).then(value =>
            String(value || ''),
          ),
          request.cancelToken.promise.then(() => ''),
        ]);
  } catch (error) {
    if (isLatestAppraisalRequest(request)) {
      CatchReturnError(error);
    }
    finishAppraisalRequest(request);
    return undefined;
  }
  if (!isAppraisalRequestSessionCurrent(request)) {
    finishAppraisalRequest(request);
    return undefined;
  }
  let URL = baseUrl + '/appraisalDetails/' + encryptData(domainName);
  if (isLatestAppraisalRequest(request)) {
    store.dispatch({ type: APPRAISAL_LOADING, payload: true });
  }
  let referrerURL = document.referrer;
  if (referrerURL && referrerURL.includes(redirect_URL)) {
    referrerURL = redirect_URL + '/appraisal';
  }
  return Axios.put(
    URL,
    {referrerURL, botToken},
    getAppraisalRequestConfig(request),
  )
    .then((res) => {
      if (!isAppraisalRequestSessionCurrent(request)) return undefined;
      let data = res['data'];
      const isLatestRequest = isLatestAppraisalRequest(request);
      if (isLatestRequest) {
        store.dispatch({ type: APPRAISAL_LOADING, payload: false });
      }
      if (res.status === 200) {
        // getAlternateDomains(domainName)
        const {appraisalSearchHistory} = store.getState().appraisalReducer;
        const appraisals = mergeAppraisalHistory(
          [data],
          _.isArray(appraisalSearchHistory) ? appraisalSearchHistory : [],
        );
        store.dispatch({ type: APPRAISAL_SEARCH_HISTORY, payload: appraisals });
        if (isLatestRequest) {
          store.dispatch({ type: APPRAISAL_DETAIL, payload: data });
        }
        // Always refresh from the allowance endpoint. An embedded allowance can
        // belong to an older UTC day or auth session when appraisal responses
        // complete out of order.
        getAppraisalAllowance();
      } else if (isLatestRequest) {
        store.dispatch({ type: APPRAISAL_ERROR, payload: data });
        getAppraisalAllowance();
      } else {
        getAppraisalAllowance();
      }
      return res;
    })
    .catch((err) => {
      if (Axios.isCancel(err) || !isAppraisalRequestSessionCurrent(request)) {
        return undefined;
      }
      if (isLatestAppraisalRequest(request)) {
        store.dispatch({ type: APPRAISAL_LOADING, payload: false });
      }
      CatchReturnError(err);
      if (isAppraisalRequestSessionCurrent(request)) {
        getAppraisalAllowance();
      }
      return undefined;
    })
    .finally(() => finishAppraisalRequest(request));
};
